import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const IDoNothingHome = () => {
  // Dummy Timer State
  const [seconds, setSeconds] = useState(0);
  const [active, setActive] = useState(false);

  useEffect(() => {
    let interval = null;
    if (active && seconds > 0) {
      interval = setInterval(() => setSeconds((prev) => prev - 1), 1000);
    } else if (seconds === 0) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [active, seconds]);

  const startTimer = () => {
    setSeconds(15 * 60); // 15 min dummy timer
    setActive(true);
  };

  const levels = [
    {
      level: "Level 1 – Quick Wins",
      items: [
        { title: "C2C Reseller", desc: "Resell Think5Whys products, courses, contests.", icon: "fa-solid fa-store" },
        { title: "Referral Earning", desc: "Invite friends, earn wallet credits.", icon: "fa-solid fa-user-plus" },
        { title: "Participate in Contests", desc: "Spend & win, gamified quizzes.", icon: "fa-solid fa-trophy" },
      ],
    },
    {
      level: "Level 2 – Micro Ventures",
      items: [
        { title: "Boutique Quick Delivery", desc: "Start your hyperlocal curated delivery services.", icon: "fa-solid fa-truck" },
        { title: "Aggregator / Wholesale / Brokerage", desc: "Create a niche digital store, earn on margins.", icon: "fa-solid fa-handshake" },
      ],
    },
    {
      level: "Level 3 – Knowledge Ventures",
      items: [
        { title: "Write, Publish & Sell Books", desc: "Use Think5Whys ecosystem to publish globally.", icon: "fa-solid fa-book-open" },
        { title: "Open Digital School / IT Tutorial", desc: "Monetize knowledge via micro-courses.", icon: "fa-solid fa-school" },
        { title: "Launch Certification Program", desc: "Issue badges using Think5Whys infra.", icon: "fa-solid fa-certificate" },
      ],
    },
    {
      level: "Level 4 – Professional Services",
      items: [
        { title: "Boutique Audit Services", desc: "Audit startups, MSMEs with smart templates.", icon: "fa-solid fa-chart-line" },
        { title: "Advisory / Consultancy", desc: "Sell consulting, coaching, frameworks.", icon: "fa-solid fa-users" },
        { title: "C2C Seller Hub", desc: "Sell digital or physical products seamlessly.", icon: "fa-solid fa-store" },
      ],
    },
  ];

  return (
    <section className="bg-gradient-to-r from-indigo-700 to-purple-700 min-h-screen text-white flex flex-col">
      
      {/* Hero */}
      <div className="text-center py-10 px-6">
        <h1 className="text-2xl font-bold mb-4">I Do Nothing 🚀</h1>
        <div className="bg-indigo-900 rounded-2xl shadow-xl py-6 px-6 max-w-4xl mx-auto">
          <h3 className="text-xl font-bold mb-2">🌍 Vision</h3>
          <p className="max-w-3xl mx-auto mb-2">
            A global anti-distraction movement: instead of wasting hours on entertainment,
            people convert micro-moments into entrepreneurship. India-first → World-next.
          </p>
          <h4 className="text-xl font-semibold">“Do Nothing. Unlock Everything.”</h4>
          <p className="text-xl max-w-3xl mx-auto mb-4">
            Transform 15 minutes of “nothing time” into income streams, learning, and digital entrepreneurship.
          </p>
          <Link
            to="/get-started"
            className="bg-yellow-500 hover:bg-yellow-400 text-black font-semibold py-3 px-6 rounded-lg shadow-lg transition"
          >
            Do “Something”
          </Link>
        </div>
      </div>

      {/* Do Nothing Timer */}
      <div className="bg-gray-800 text-white rounded-2xl mx-6 md:mx-20 p-8 text-center shadow-2xl -mt-8 mb-10">
        <h2 className="text-xl font-bold mb-4">⏳ Do Nothing Timer</h2>
        {active ? (
          <p className="text-lg font-semibold mb-4">
            Time Left: {Math.floor(seconds / 60)}:{("0" + (seconds % 60)).slice(-2)}
          </p>
        ) : (
          <p className="mb-4 text-gray-300">Take 15 minutes off scrolling. Unlock rewards when time is up!</p>
        )}
        <button
          onClick={startTimer}
          disabled={active}
          className="bg-indigo-600 text-white px-6 py-3 rounded-lg hover:bg-indigo-500 disabled:bg-gray-500 transition"
        >
          {active ? "Running..." : "Start 15 Min Nothing Timer"}
        </button>
      </div>

      {/* Opportunity Ladder */}
      <div className="bg-gray-800 rounded-2xl mx-6 md:mx-20 py-8 px-6 md:px-20 shadow-2xl">
        <h2 className="text-xl font-bold text-center mb-6">📈 Opportunity Ladder</h2>
        {levels.map((lvl, i) => (
          <div key={i} className="mb-12">
            <h3 className="text-lg font-semibold mb-4 text-yellow-300">{lvl.level}</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {lvl.items.map((item, idx) => (
                <div
                  key={idx}
                  className="bg-black bg-opacity-60 rounded-xl shadow-lg p-6 text-center hover:shadow-2xl hover:scale-105 transition"
                >
                  <i className={`${item.icon} text-3xl text-yellow-300 mb-4`}></i>
                  <h4 className="text-m font-semibold mb-2">{item.title}</h4>
                  <p className="text-gray-200 mb-3">{item.desc}</p>
                  <Link
                    to="/coming-soon"
                    className="text-yellow-300 font-semibold hover:underline"
                  >
                    Explore →
                  </Link>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Gamification */}
      <div className="bg-gray-800  rounded-2xl mx-6 md:mx-20 mt-10 mb-8 py-8 px-6 md:px-20 shadow-2xl">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4 text-gray-100">
          <p className="mb-3">✅ Progressive Unlocking of Levels</p>
          <p className="mb-3">🔥 30-Day Entrepreneur Streaks</p>
          <p className="mb-3">👥 Squads & Teams for Collaboration</p>
          <p className="mb-3">🌍 Global Leaderboard of Top Do-Nothings</p>
        </div>
      </div>
      
      {/* Footer */}
      <footer className="bg-gray-900 py-6 px-6 md:px-20 mt-auto rounded-t-2xl">
        <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left">
          <p className="text-sm text-gray-400">&copy; 2025 Think5Whys Global DeepTech Solutions. All rights reserved.</p>
          <div className="flex space-x-6 mt-4 md:mt-0 text-sm">
            <Link to="/about-us" className="text-white hover:text-yellow-400 transition">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-yellow-400 transition">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-yellow-400 transition">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-yellow-400 transition">Contact</Link>
          </div>
        </div>
      </footer>
    </section>
  );
};

export default IDoNothingHome;
